/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, since: NonNullable<unknown> }} Valve_Not_On_BodyInputs */



/**
* | since | output |
* | --- | --- |
* | "false" | "Th. head is not installed on a valve body" |
* | "true" | "Th. head is not installed on a valve body since {date}" |
* | * | "Th. head is not installed on a valve body" |
*
* @param {Valve_Not_On_BodyInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const valve_not_on_body = /** @type {((inputs: Valve_Not_On_BodyInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Valve_Not_On_BodyInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.since === "false") return /** @type {LocalizedString} */ (`Th. head is not installed on a valve body`);
		if (i?.since === "true") return /** @type {LocalizedString} */ (`Th. head is not installed on a valve body since ${i?.date}`);
		return /** @type {LocalizedString} */ (`Th. head is not installed on a valve body`)
	}
	{
		if (i?.since === "false") return /** @type {LocalizedString} */ (`La tête thermostatique n'est pas installée sur un corps de vanne`);
		if (i?.since === "true") return /** @type {LocalizedString} */ (`La tête thermostatique n'est pas installée sur un corps de vanne depuis le ${i?.date}`);
		return /** @type {LocalizedString} */ (`La tête thermostatique n'est pas installée sur un corps de vanne`)
	}
});